/**
 * Motivos de fallo que el visor sabe explicar. Se mapean 1:1 con los codigos que
 * devuelve la API de la Fase 3, mas los que solo existen del lado del cliente.
 */
export type MotivoFallo =
  | "link_invalido"
  | "link_expirado"
  | "modelo_no_encontrado"
  | "fallo_de_red"
  | "modelo_corrupto";

export interface TextoFallo {
  titulo: string;
  detalle: string;
}

const TEXTOS: Record<MotivoFallo, TextoFallo> = {
  link_invalido: {
    titulo: "Link invalido",
    detalle:
      "Este enlace no es valido o esta incompleto. Copialo de nuevo completo, sin cortar nada despues del #.",
  },
  link_expirado: {
    titulo: "Link expirado",
    detalle: "Este enlace ya vencio. Pedile al remitente que te genere uno nuevo.",
  },
  modelo_no_encontrado: {
    titulo: "Modelo no encontrado",
    detalle: "El modelo de este enlace ya no esta disponible.",
  },
  fallo_de_red: {
    titulo: "Fallo de red",
    detalle:
      "No se pudo descargar el modelo. Revisa tu conexion y volve a cargar la pagina.",
  },
  modelo_corrupto: {
    titulo: "No se pudo abrir el modelo",
    detalle: "El archivo del modelo llego danado o incompleto. Volve a cargar la pagina.",
  },
};

/** Error que el visor sabe convertir en una pantalla explicita, nunca en blanco. */
export class FalloDeVisor extends Error {
  readonly motivo: MotivoFallo;

  constructor(motivo: MotivoFallo, causa?: unknown) {
    super(TEXTOS[motivo].titulo, causa === undefined ? undefined : { cause: causa });
    this.name = "FalloDeVisor";
    this.motivo = motivo;
  }

  get texto(): TextoFallo {
    return TEXTOS[this.motivo];
  }
}

export function comoFallo(causa: unknown): FalloDeVisor {
  return causa instanceof FalloDeVisor ? causa : new FalloDeVisor("fallo_de_red", causa);
}
